import ApplicationAdapter from "./application";

export default class ColocationRackAdapter extends ApplicationAdapter {}
